// This file will display the avilable popup as grid layout
import React, { Fragment, useEffect, useState} from 'react';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import ResourcesPopupModal from './ResourcesPopupModal';
import { Helmet } from "react-helmet";

import "./PopupModal.css";

const PopupResources = (props) => {

    const API_URL = process.env.REACT_APP_PUBLIC_API_URL;
    const API_KEY = process.env.REACT_APP_SITE_KEY;

    const [popupList, setPopupList] = useState([]);

    useEffect(()=> {

        const getPopupList = async () => {
            try {
                const res = await fetch(
                    `${API_URL}/getpopups`,
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ sitekey: API_KEY }),
                    }
                );

                if (!res.ok){
                    throw new Error(`HTTP error ${res.status}`)
                }

                const response = await res.json();

                console.log("JSON response", response.data.popups);
                if(response.data.popups)
                    setPopupList(response.data.popups);

            } catch(error ) {
                console.log("Error ", error);
            }
        }

        getPopupList();

    }, [API_KEY, API_URL]);

    return (
        <Fragment>
            <Helmet>
                <title>Resources || JJFIndia</title>
            </Helmet>
            <Header hclass={'header--styleFour'} />
            <main className="page_content">
                <PageTitle pageTitle={'Popup Resources'} pagesub={'popup resources'} />
                <section className='d-flex align-items-center justify-content-center mt-5 mb-5'>
                    <div className="resource-grid" >
                        {popupList && popupList.map((popup, index) => {
                            const image = popup.guide.image.url;
                            const title = popup.guide.title;
                            const desc = popup.guide.desc;

                            return (
                                <>
                                <ResourcesPopupModal image={image} title={title} desc={desc} popup={popup}/>
                                </>
                                // <div className='d-flex align-items-center justify-content-center' key={index}>
                                //     <div key={index} className="popup-wrapper d-flex">
                                //         <div className="popup-left">
                                //         {image && <img src={image} alt={title} className="popup-image" />}
                                //         </div>

                                //         <div className="popup-right">
                                //         <p className="popup-desc">{desc}</p>
                                //         <h2 className="popup-title">{title}</h2>
                                //         <form className="popup-form" onSubmit={(e) => e.preventDefault()} noValidate>
                                //             <input
                                //             type="email"
                                //             placeholder="Email ID"
                                //             className="popup-input"
                                //             // value={email}
                                //             // onChange={(e) => setEmail(e.target.value)}
                                //             // required
                                //             />
                                //             <button type="submit" className="popup-btn" >
                                //                 Start Now!
                                //             </button>

                                //             {/* {message && (
                                //             <p
                                //                 style={{
                                //                 marginTop: "10px",
                                //                 color: error ? "red" : "green",
                                //                 }}
                                //             >
                                //                 {message}
                                //             </p>
                                //             )} */}
                                //         </form>
                                //         </div>
                                //         </div>
                                //     </div>
                            )
                        })
                    }
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default PopupResources;
